<div
	@fadeInOut
	class="fixed inset-0 z-50 flex items-center justify-center bg-peps-dark-900/50"
	(click)="onBackgroundClick($event)"
>
	<div
		@scaleInOut
		class="h-full w-full bg-peps-dark-700 relative p-8 md:h-fit xl:w-10/12"
	>
		<div class="flex flex-row items-center gap-2 w-fit">
			<img src="assets/images/team_peps_logo.avif" alt="Team Peps" class="h-10" />
			<span class="uppercase text-2xl">{{ 'component.place-information.title' | translate }}</span>
		</div>
		<button
			class="absolute top-4 right-4 text-peps-dark-200 hover:text-white transition cursor-pointer"
			(click)="closeInformationModal()">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-10">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
			</svg>
		</button>

		<div class="grid grid-cols-1 md:grid-cols-3 gap-4 my-4 py-2 px-6 max-h-full md:max-h-[450px] overflow-y-scroll custom-vertical-scrollbar">
			<div class="col-span-2 font-notosans flex flex-col gap-4 px-4">
				<p class="text-justify">
					{{ 'component.place-information.first-paragraph.le' | translate }} <span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">PPLACE</span> {{ 'component.place-information.first-paragraph.text' | translate }}
				</p>
				<p class="text-justify">
					{{ 'component.place-information.second-paragraph.text' | translate }}
				</p>
				<p class="text-justify">
					{{ 'component.place-information.first-paragraph.le' | translate }} <span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">PPLACE</span> {{ 'component.place-information.third-paragraph.text' | translate }}
				</p>
				<p class="text-justify">
					{{ 'component.place-information.fourth-paragraph.le' | translate }}
				</p>

			</div>
			<div class="flex flex-col gap-4 px-4">
				<span class="uppercase border-b-2 border-b-peps-gold w-fit text-xl">{{ 'component.place-information.key-points.title' | translate }}</span>
				<div>
					<ul class="space-y-2 font-notosans text-sm">
						<li>
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">1 pixel</span>
							{{ 'component.place-information.key-points.recharge-in' | translate }}
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">15</span>
							{{ 'component.place-information.key-points.seconds' | translate }}
						</li>
						<li>
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">+3</span>
							{{ 'component.place-information.key-points.add-pixels-max' | translate }}
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">10 pixels</span>
							{{ 'component.place-information.key-points.placed' | translate }}
						</li>
						<li>
							{{ 'component.place-information.key-points.challenges' | translate }}
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">{{ 'component.place-information.key-points.increase-max' | translate }}</span>
							{{ 'component.place-information.key-points.of' | translate }} pixels</li>
						<li>
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">140+</span>
							{{ 'component.place-information.key-points.available-color' | translate }}
						</li>
						<li>
							{{ 'component.place-information.key-points.canvas' | translate }}
							<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">10 000 x 10 000</span>
						</li>
					</ul>
				</div>
				<img src="assets/images/pplace-logo.png" alt="PPlace logo" class="w-full my-12 md:my-4" />
			</div>
		</div>
	</div>
</div>
